import { actionColors, actionIcons, classNames } from "../../utils/formatters";

import { Note } from "../../types/Note";

const WorkflowHistoryPanel = ({ historyItems }: any) => {
  return (
    <div className="bg-white overflow-hidden shadow rounded-lg divide-y divide-gray-200 mb-8">
      <div className="px-4 py-5 sm:px-6">
        <h2 className="font-bold text-gray-700">Workflow History</h2>
      </div>
      <div className="px-4 py-5 sm:p-6">
        <div className="flow-root">
          {historyItems.length ? (
            <ul className="-mb-8">
              {historyItems
                .sort(function (a: any, b: any) {
                  return b.SK - a.SK;
                })
                .map((historyItem: Note, i: any) => (
                  <li key={i}>
                    <div className="relative pb-8">
                      {i !== historyItems.length - 1 ? (
                        <span
                          className="absolute top-5 left-5 -ml-px h-full w-0.5 bg-gray-200"
                          aria-hidden="true"
                        />
                      ) : null}
                      <div className="relative flex items-start space-x-3">
                        <>
                          <div>
                            <div className="relative px-1">
                              <div className="h-8 w-8 bg-gray-100 rounded-full ring-8 ring-white flex items-center justify-center">
                                {actionIcons(historyItem.action.toLowerCase())}
                              </div>
                            </div>
                          </div>
                          <div className="min-w-0 w-full">
                            <div className="flex flex-row">
                              <div className="text-l flex-1 font-medium text-gray-900">
                                {historyItem.stepName}
                              </div>
                              <div
                                className="text-right leading-loose text-xs whitespace-nowrap "
                                title={new Date(
                                  parseInt(historyItem.SK)
                                ).toLocaleString()}
                              >
                                <span className="text-gray-500 bg-gray-100 px-2 py-1 rounded cursor-pointer">
                                  <time
                                    dateTime={new Date(
                                      parseInt(historyItem.SK)
                                    ).toString()}
                                  >
                                    {new Date(
                                      parseInt(historyItem.SK)
                                    ).toLocaleString("default", {
                                      month: "short",
                                      day: "numeric"
                                    })}
                                  </time>
                                </span>
                              </div>
                            </div>
                            <div>
                              <div className="text-sm">
                                <a
                                  href={`mailto:${historyItem.user}`}
                                  className="font-medium text-xs text-green-500 underline hover:no-underline"
                                >
                                  {historyItem.user}
                                </a>
                              </div>
                              <div className="my-2 text-sm text-gray-500 capitalize">
                                <span
                                  className={classNames(
                                    actionColors[
                                      historyItem.action.toLowerCase()
                                    ] || "bg-gray-100 text-gray-800",
                                    "inline-flex items-center px-2.5 py-0.5 rounded-md text-sm font-medium "
                                  )}
                                >
                                  {historyItem.action}
                                </span>
                              </div>
                              <div className="mt-0.5 text-sm text-gray-500">
                                {historyItem.notes}
                              </div>
                            </div>
                          </div>
                        </>
                      </div>
                    </div>
                  </li>
                ))}
            </ul>
          ) : (
            <div className="text-gray-400 w-full text-center text-sm italic">
              No Records Found
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default WorkflowHistoryPanel;
